import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { GiHamburgerMenu } from "react-icons/gi";
import { VscChromeClose } from "react-icons/vsc";
import { useNavigate, useLocation } from "react-router-dom";

import home from "../assets/icons/home.png";
import home2 from "../assets/icons/home2.png";
import visit from "../assets/icons/visit.png";
import visit2 from "../assets/icons/visit2.png";
import headset from "../assets/icons/headset.png";
import headset2 from "../assets/icons/headset2.png";
import Logo2 from "../assets/logo2.png";

export default function Navbar() {
  const [navbarState, setNavbarState] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const getActivePage = () => {
    if (location.pathname === "/") return "home";
    if (location.pathname.includes("products")) return "products";
    if (location.pathname.includes("contact")) return "contact";
    return "home";
  };

  const navbarStateName = getActivePage();

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleOutsideClick = () => {
      setNavbarState(false);
    };

    document.documentElement.addEventListener("click", handleOutsideClick);

    return () => {
      document.documentElement.removeEventListener(
        "click",
        handleOutsideClick
      );
    };
  }, []);

  const handleNavigation = (target) => {
    navigate(target);

    setNavbarState(false);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Nav>
        <div
          className="brand"
          onClick={(e) => {
            e.stopPropagation();
            handleNavigation("/");
          }}
        >
          <div className="logo">
            {/* <img src={Logo2} alt="ASR Academy Logo" className="logoImg" /> */}
            <h2>ASR Academey</h2>
          </div>

          <div
            className="toggle"
            onClick={(e) => {
              e.stopPropagation();
              setNavbarState((prev) => !prev);
            }}
          >
            {navbarState ? <VscChromeClose /> : <GiHamburgerMenu />}
          </div>
        </div>

        <ul className="links">
          <li onClick={() => handleNavigation("/")}>
            <img
              src={navbarStateName === "home" ? home2 : home}
              alt="Home"
            />
            <span
              className={
                navbarStateName === "home" ? "active" : "passive"
              }
            >
              Home
            </span>
          </li>

          <li onClick={() => handleNavigation("/products")}>
            <img
              src={navbarStateName === "products" ? visit2 : visit}
              alt="Training Center"
            />
            <span
              className={
                navbarStateName === "products" ? "active" : "passive"
              }
            >
              Training Center
            </span>
          </li>

          <li onClick={() => handleNavigation("/contact")}>
            <img
              src={navbarStateName === "contact" ? headset2 : headset}
              alt="Contact Us"
            />
            <span
              className={
                navbarStateName === "contact" ? "active" : "passive"
              }
            >
              Contact Us
            </span>
          </li>
        </ul>
      </Nav>

      <ResponsiveOverlay
        state={navbarState}
        onClick={() => setNavbarState(false)}
      />

      <ResponsiveNav state={navbarState}>
        <ul>
          <li onClick={() => handleNavigation("/")}>
            <img
              src={navbarStateName === "home" ? home2 : home}
              alt="Home"
            />
            <span
              className={
                navbarStateName === "home" ? "active" : "passive"
              }
            >
              Home
            </span>
          </li>

          <li onClick={() => handleNavigation("/products")}>
            <img
              src={navbarStateName === "products" ? visit2 : visit}
              alt="Training Center"
            />
            <span
              className={
                navbarStateName === "products" ? "active" : "passive"
              }
            >
              Training Center
            </span>
          </li>

          <li onClick={() => handleNavigation("/contact")}>
            <img
              src={navbarStateName === "contact" ? headset2 : headset}
              alt="Contact Us"
            />
            <span
              className={
                navbarStateName === "contact" ? "active" : "passive"
              }
            >
              Contact Us
            </span>
          </li>
        </ul>
      </ResponsiveNav>
    </>
  );
}

/* =========================
   DESKTOP NAVBAR
========================= */

const Nav = styled.nav`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 72px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 4vw;

  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  z-index: 1000;

  box-sizing: border-box;

  .brand {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .logoImg {
    width: 48px;
    height: 48px;

    object-fit: contain;
    display: block;
  }

  h2 {
    margin: 0;

    font-family: "Times New Roman", Times, serif;

    font-size: 1.45rem;
    font-weight: 700;

    color: #1b1b1b;

    white-space: nowrap;
  }

  .toggle {
    display: none;
  }

  .links {
    display: flex;
    align-items: center;

    gap: 2.5rem;

    margin: 0;
    padding: 0;

    list-style: none;
  }

  .links li {
    display: flex;
    align-items: center;

    gap: 8px;

    cursor: pointer;

    font-size: 0.98rem;
    font-weight: 600;

    transition: 0.25s ease;
  }

  .links li img {
    width: 18px;
    height: 18px;

    object-fit: contain;
  }

  .links li span {
    transition: color 0.25s ease;
  }

  .links li:hover span {
    color: #fc4958;
  }

  .active {
    color: #fc4958;
    font-weight: 700;
  }

  .passive {
    color: #222222;
  }

  /* =========================
     TABLET / MOBILE
  ========================= */

  @media screen and (max-width: 1080px) {
    height: 64px;

    padding: 0 20px;

    .brand {
      width: 100%;

      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .logo {
      gap: 8px;
    }

    .logoImg {
      width: 38px;
      height: 38px;
    }

    h2 {
      font-size: 1.15rem;
    }

    .links {
      display: none;
    }

    .toggle {
      width: 40px;
      height: 40px;

      display: flex;
      align-items: center;
      justify-content: center;

      cursor: pointer;

      color: #222222;

      font-size: 25px;

      border-radius: 8px;

      transition: 0.2s ease;
    }

    .toggle:hover {
      color: #fc4958;
      background: rgba(252, 73, 88, 0.08);
    }
  }

  @media screen and (max-width: 480px) {
    padding: 0 16px;

    .logoImg {
      width: 34px;
      height: 34px;
    }

    h2 {
      font-size: 1rem;
    }

    .toggle {
      font-size: 23px;
    }
  }
`;

/* =========================
   MOBILE OVERLAY
========================= */

const ResponsiveOverlay = styled.div`
  position: fixed;

  inset: 0;

  background: rgba(0, 0, 0, 0.35);

  z-index: 1001;

  opacity: ${({ state }) => (state ? 1 : 0)};
  visibility: ${({ state }) => (state ? "visible" : "hidden")};

  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;

  @media screen and (min-width: 1081px) {
    display: none;
  }
`;

/* =========================
   MOBILE MENU
========================= */

const ResponsiveNav = styled.div`
  position: fixed;

  top: 0;
  right: ${({ state }) => (state ? "0" : "-320px")};

  width: min(320px, 80vw);
  height: 100vh;

  background: #ffffff;

  z-index: 1002;

  box-shadow: -5px 0 25px rgba(0, 0, 0, 0.12);

  transition: right 0.3s ease;

  box-sizing: border-box;

  padding-top: 80px;

  ul {
    width: 100%;

    margin: 0;
    padding: 0 20px;

    list-style: none;

    box-sizing: border-box;
  }

  li {
    display: flex;
    align-items: center;

    gap: 14px;

    width: 100%;

    padding: 15px 12px;

    margin-bottom: 8px;

    border-radius: 10px;

    cursor: pointer;

    box-sizing: border-box;

    transition:
      background 0.2s ease,
      color 0.2s ease;
  }

  li:hover {
    background: rgba(252, 73, 88, 0.08);
  }

  li img {
    width: 20px;
    height: 20px;

    object-fit: contain;
  }

  li span {
    font-size: 1rem;

    transition: color 0.2s ease;
  }

  .active {
    color: #fc4958;
    font-weight: 700;
  }

  .passive {
    color: #222222;
    font-weight: 500;
  }

  @media screen and (min-width: 1081px) {
    display: none;
  }
`;
